import React from 'react';
import { TargetCloudSelector as CommonTargetCloudSelector } from '../../TargetCloudSelector';

/**
 * Legacy wrapper for Target Cloud Selector component
 * @param {Array} processedCloudAccounts - Processed cloud accounts with disabled flags
 * @param {Function} onTargetAccountChange - Handler for target account selection
 * @param {boolean} shouldPreselect - Whether account should be preselected
 * @param {boolean} isMigrateByVM - Whether migration is by VM
 * @param {Object} selectedAccount - Currently selected account
 */
export const TargetCloudSelector = ({
    processedCloudAccounts,
    onTargetAccountChange,
    shouldPreselect,
    isMigrateByVM,
    selectedAccount,
}) => {
    return (
        <CommonTargetCloudSelector
            processedCloudAccounts={processedCloudAccounts}
            onChange={(accountId) => onTargetAccountChange(accountId, processedCloudAccounts)}
            shouldPreselect={shouldPreselect}
            isMigrateByVM={isMigrateByVM}
            selectedAccount={selectedAccount}
            useFormItem={true}
            showTooltip={true}
            showApplianceWarning={true}
            label="Select Target Cloud"
            placeholder="Select Target Cloud"
        />
    );
};
